module.exports = __webpack_public_path__ + "img/7-map.2b590667.jpg";